/**
 * 各语言 hub/{locale}.js 在 createHubLocale 时注册 ARTICLE_BODIES
 * zh 全文在 zh.js，不注册
 */
var registry = {
  en: null,
  ja: null,
  ko: null,
  fr: null,
  es: null,
  it: null,
  de: null,
  pt: null,
  pl: null,
  ar: null
}

function registerArticleBodies(locale, bodies) {
  var lang = String(locale || '').toLowerCase()
  if (!lang || lang === 'zh') return
  registry[lang] = bodies || null
}

function getArticleBody(locale, slug) {
  var lang = String(locale || '').toLowerCase()
  if (!lang || lang === 'zh') return null
  var pack = registry[lang]
  if (pack && pack[slug]) return pack[slug]
  if (lang !== 'en' && registry.en && registry.en[slug]) return registry.en[slug]
  return null
}

module.exports = {
  registerArticleBodies: registerArticleBodies,
  getArticleBody: getArticleBody
}
